export const SECTION_HOMEPAGE = 'homepage';
export const SECTION_CATEGORY = 'category';
export const SECTION_TAGS = 'tags';
export const SECTION_POST_LIST = 'post-list';
export const SECTION_RELATED_POSTS = 'related-posts';
export const SECTION_MY_POSTS = 'my-posts';
export const SECTIONS = [
    SECTION_HOMEPAGE,
    SECTION_CATEGORY,
    SECTION_POST_LIST,
    SECTION_RELATED_POSTS,
    SECTION_MY_POSTS,
];
export const FEED_PAGE_SECTIONS = [SECTION_HOMEPAGE, SECTION_CATEGORY];
//# sourceMappingURL=sections.js.map